import BackTop from './backtop';

export default BackTop;
